/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { GblContext } from "providers/formatter";
import { useRedirect } from "react-admin";
import { Loading, Error, useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { Box, FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import { getAssetDisposalSearchList } from "services/asset";
import DialogAssetRegister from "./DialogAssetRegister";
import DialogSelectType from "./DialogSelectType";
import MuiTranslateTable from "components/MuiTranslateTable";
import ActionMenu from "components/ActionMenu";
import CustomTablePagination from "components/CustomTablePagination";
import DatePickerFormat from "components/DatePickerFormat";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { permissionName } from "utils/constants";
import ModelUriQueryString from "models/uriQueryString";
import { addDays, startOfMonth, endOfMonth } from "date-fns";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  statusDraft: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
  },
  statusNormal: {
    backgroundColor: "#2196f3",
    color: "white",
  },
  statusVoid: {
    backgroundColor: "#e57373",
    color: "white",
  },
}));

const List = (props) => {
  const classes = useStyles();
  const { basePath, permissions } = props;
  const translate = useTranslate();
  const arrFilterDate = ["All", "Disposal Date"];
  //initial Value with window.sessionStorage
  const ws = window.sessionStorage;
  let t = localStorage.getItem("Tenant");
  const filterValue =
    ws.getItem("basePath") === basePath && ws.getItem(`${t}_searchDetails`)
      ? JSON.parse(ws.getItem(`${t}_searchDetails`)).filterValue
      : undefined;
  const searchQuery =
    ws.getItem("basePath") === basePath && ws.getItem(`${t}_searchDetails`)
      ? JSON.parse(ws.getItem(`${t}_searchDetails`)).searchQuery
      : undefined;
  const searchResults =
    ws.getItem("basePath") === basePath && ws.getItem(`${t}_searchDetails`)
      ? JSON.parse(ws.getItem(`${t}_searchDetails`)).searchResults
      : undefined;

  const { settingAll, DateToString, ToMySqlDate } = useContext(GblContext);
  const { SettingClosePeriod } = settingAll;
  const { ClosePeriodAsset } = SettingClosePeriod;
  const [loading, setLoading] = useState(true);
  const [error] = useState();
  const [Data, setData] = useState(searchResults ? searchResults : undefined);
  const [Paging, setPaging] = useState();
  const [uriQueryString, setUriQueryString] = useState({
    Limit: searchQuery ? searchQuery.Limit : ModelUriQueryString.Limit,
    Page: searchQuery ? searchQuery.Page : ModelUriQueryString.Page,
    OrderBy: searchQuery ? searchQuery.OrderBy : ModelUriQueryString.OrderBy,
    WhereGroupList: searchQuery ? searchQuery.WhereGroupList : ModelUriQueryString.WhereGroupList,
    Exclude: searchQuery ? searchQuery.Exclude : ModelUriQueryString.Exclude,
    WhereRaw: searchQuery ? searchQuery.WhereRaw : ModelUriQueryString.WhereRaw,
    WhereLike: searchQuery ? searchQuery.WhereLike : ModelUriQueryString.WhereLike,
    WhereLikeFields: searchQuery ? searchQuery.WhereLikeFields : ModelUriQueryString.WhereLikeFields,
  });
  const [searchText, setSearchText] = useState(filterValue ? filterValue.searchValue : undefined);
  const [optionDate, setOptionDate] = useState(filterValue ? filterValue.optionDate : "Disposal Date");

  const [filterDate, setFilterDate] = useState({
    from: filterValue ? new Date(filterValue.filterDate.from) : startOfMonth(addDays(new Date(ClosePeriodAsset), 1)),
    to: filterValue ? new Date(filterValue.filterDate.to) : endOfMonth(new Date()),
  });

  const redirect = useRedirect();

  const handleFilterList = () => {
    let fromMySqlDate = ToMySqlDate(filterDate.from);
    let toMySqlDate = ToMySqlDate(filterDate.to);

    switch (optionDate) {
      case "Disposal Date":
        uriQueryString.WhereGroupList = [
          {
            AndOr: "And",
            ConditionList: [
              {
                AndOr: "And",
                Field: "DisposalDate",
                Operator: ">=",
                Value: fromMySqlDate,
              },
              {
                AndOr: "And",
                Field: "DisposalDate",
                Operator: "<=",
                Value: toMySqlDate,
              },
              {
                AndOr: "And",
                Field: "DisposalType",
                Operator: "!=",
                Value: "I",
              },
            ],
          },
        ];
        break;
      default:
        uriQueryString.WhereGroupList = [
          {
            AndOr: "And",
            ConditionList: [],
          },
          {
            AndOr: "And",
            Field: "DisposalType",
            Operator: "!=",
            Value: "I",
          },
        ];
        break;
    }

    uriQueryString.WhereLikeFields = [
      "DisposalId",
      "DATE_FORMAT(DisposalDate, '%d/%m/%Y')",
      "AstId",
      "AstNo",
      "AstName",
    ];
  };

  const fetchSearchList = async (uriQueryString) => {
    setLoading(true);
    handleFilterList();
    uriQueryString.Exclude = [
      "LastCost",
      "Qty",
      "TotalCost",
      "NetBook",
      "SaleAmt",
      "AstAmt",
      "ReduceAmt",
      "Depre",
      "AccuDepreAmt",
      "SaleDeptCode",
      "SaleAccCode",
      "GainLossDeptCode",
      "GainLossAccCode",
      "CategoryCode",
      "DepartmentCode",
      "LocationCode",
      "AstPhoto",
      "SerialNo",
      "Spec",
      "UserModified",
      "LastModified",
    ];
    const { Data, Paging } = await getAssetDisposalSearchList(uriQueryString);
    if (Data) {
      setData(Data);
      setPaging(Paging);
      setUriQueryString(uriQueryString);
    } else {
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSearchList(uriQueryString);
  }, [uriQueryString]);

  const handleRequestSort = (property, order) => {
    uriQueryString.OrderBy = { [property]: order };
    fetchSearchList(uriQueryString);
  };

  if (loading) return <Loading />;
  if (error) return <Error />;
  if (!Data) return null;

  const handleChangePage = (e, newPage) => {
    uriQueryString.Page = newPage + 1;
    fetchSearchList(uriQueryString);
  };

  const handleChangeRowsPerPage = (e) => {
    let newRowsPerPage = parseInt(e.target.value);
    uriQueryString.Limit = newRowsPerPage;
    fetchSearchList(uriQueryString);
  };

  const handleTableChange = (action, tableState) => {
    if (action === "onSearchClose") {
      //clear window.sessionstorage (when user click close icon)
      ws.clear();
      setSearchText();
      uriQueryString.WhereLike = "";
      uriQueryString.WhereLikeFields = [];
      fetchSearchList(uriQueryString);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    uriQueryString.WhereLike = `%${value}%`;
    uriQueryString.WhereLikeFields = [
      "DisposalId",
      "DATE_FORMAT(DisposalDate, '%d/%m/%Y')",
      "AstId",
      "AstNo",
      "AstName",
    ];
    uriQueryString.Page = 1;
    fetchSearchList(uriQueryString);
  };

  const columns = [
    {
      name: "DisposalId",
      label: " ",
      options: {
        filter: false,
        viewColumns: false,
        customBodyRender: (value) => {
          return (
            <a href={`#${basePath}/${value}/show`}>
              <VisibilityIcon
                fontSize="small"
                color="primary"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  //set window.storage value
                  const filterValueObj = {
                    searchValue: searchText,
                    optionDate: optionDate,
                    filterDate: filterDate,
                  };
                  ws.setItem("basePath", basePath);
                  ws.setItem(
                    `${t}_searchDetails`,
                    JSON.stringify({
                      filterValue: filterValueObj,
                      searchQuery: uriQueryString,
                      searchDetails: Data,
                    })
                  );
                  redirect("show", basePath, value);
                }}
              />
            </a>
          );
        },
      },
    },
    {
      name: "DisposalDate",
      label: "Disposal Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return value ? DateToString(new Date(value)) : null;
        },
      },
    },
    {
      name: "Id",
      label: "Code",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "No",
      label: "Asset No.",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Remark",
      label: "Remark",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  const options = {
    filter: false, // show the filter icon in the toolbar (true by default)
    responsive: "standard",
    selectableRows: "none",
    serverSide: true,
    confirmFilters: true,
    searchText: searchText,
    searchProps: {
      onKeyUp: (e) => {
        if (e.keyCode === 13) {
          handleSearch(e.target.value);
        }
      },
    },
    download: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      return `\uFEFF${buildHead(columns)}${buildBody(data)}`;
    },
    onTableChange: (action, tableState) => handleTableChange(action, tableState),
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    sortOrder: {
      name: Object.keys(uriQueryString.OrderBy)[0],
      direction: Object.values(uriQueryString.OrderBy)[0],
    },
    onColumnSortChange: (changedColumn, direction) => {
      handleRequestSort(changedColumn, direction);
    },
    customFooter: () => {
      return (
        <CustomTablePagination
          rowsPerPageOptions={[15, 50, 100]}
          component="div"
          count={Paging?.TotalRecordCount ?? 0}
          rowsPerPage={Paging?.Limit ?? 15}
          page={Paging?.Page ? Paging.Page - 1 : 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      );
    },
  };

  const CustomFilterList = () => {
    return (
      <Box display="flex">
        <Box p={1}>
          <FormControl variant="outlined">
            <InputLabel id="viewMode">{translate("ra.fieldAbbr.select")}</InputLabel>
            <Select
              labelId="viewMode"
              label={translate("ra.fieldAbbr.select")}
              variant="outlined"
              margin="dense"
              value={optionDate}
              defaultValue={optionDate}
              onChange={(e) => {
                setUriQueryString({ ...uriQueryString, Page: 1 });
                setOptionDate(e.target.value);
              }}
            >
              {arrFilterDate.map((item, idx) => (
                <MenuItem key={idx} value={item}>
                  {translate(`ra.field.${item}`)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {optionDate !== "All" && (
          <Box p={1}>
            <DatePickerFormat
              label={translate("ra.field.From")}
              value={filterDate.from}
              onChange={(e) => {
                setUriQueryString({ ...uriQueryString, Page: 1 });
                setFilterDate((state) => ({
                  ...state,
                  from: e,
                  to: e > filterDate.to ? e : filterDate.to,
                }));
              }}
              style={{ width: 160, margin: "0 10px" }}
            />
            <DatePickerFormat
              label={translate("ra.field.To")}
              value={filterDate.to}
              onChange={(e) => {
                setUriQueryString({ ...uriQueryString, Page: 1 });
                setFilterDate((state) => ({
                  ...state,
                  to: e,
                }));
              }}
              minDate={filterDate.from}
              minDateMessage={"Date must be more than from date"}
              style={{ width: 160, margin: "0 10px" }}
            />
          </Box>
        )}
      </Box>
    );
  };

  const menuControlProp = [{ name: "Add", fnc: props.FncAddButton }];

  return (
    <div className={classes.root}>
      <ActionMenu
        menuControl={menuControlProp}
        permission={permissions.find((i) => i.Name === permissionName["Ast.Disposal"])}
      />
      <MuiTranslateTable
        title={"Asset Disposal"}
        data={Data}
        columns={columns}
        options={options}
        components={{
          TableFilterList: CustomFilterList,
        }}
      />
      {props.openSelectType && (
        <DialogSelectType open={props.openSelectType} onClose={props.onCloseSelectType} basePath={basePath} />
      )}
      {props.open && <DialogAssetRegister open={props.open} onClose={props.onClose} basePath={basePath} />}
    </div>
  );
};

export default List;
